<div class="warning-popup">
    <h2 class="m-b-13" mat-dialog-title>Cambiar Tipo de Actuación</h2>
    <div mat-dialog-content>
        <form [formGroup]="form">
            <div class="d-flex">
                <div fxFlex="100" fxFlex.gt-sm="50" class=" m-r-10">
                    <mat-form-field class="example-full-width" floatLabel="always">
                        <mat-label>Tipo de actuación</mat-label>
                        <mat-select formControlName="tipo">
                            <mat-option *ngFor="let actionType of actionTypes" [value]="actionType.value">
                                {{ actionType.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="form.get('tipo').touched && form.get('tipo').invalid">
                        <span *ngIf="form.get('tipo').errors.required">
                            Obligatorio
                        </span>
                    </mat-error>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50">
                    <mat-form-field class="example-full-width importe-medico-field" floatLabel="always">
                        <mat-label>Importe Médico</mat-label>
                        <input formControlName="importeMedico" matInput class="p-b-2 changeAct" appSpanishNumber>
                        <span matSuffix>&nbsp; €</span>
                    </mat-form-field>
                    <mat-error *ngIf="form.get('importeMedico').touched && form.get('importeMedico').invalid">
                        <span *ngIf="form.get('importeMedico').errors.min">
                            Inválido
                        </span>
                    </mat-error>
                </div>
            </div>
        </form>

        <div class="text-a-r p-t-5">
            <button (click)="save()" mat-raised-button color="accent" class="m-r-15">Guardar</button>
            <button (click)="close()" mat-raised-button color="warn">Cancelar</button>
        </div>
    </div>
</div>